import api from '../common/helpers/apiHelper';
import { ICandidate } from '../common/models/candidate/ICandidate';
import { IListData } from '../common/models/common/IListData';
import { IFilter } from '../common/models/filter/IFilter';
import { mapSortToSortReq, mapFilterToFilterReq } from '../common/helpers/filterHelper';
import { CandidateCounts } from '../common/models/candidate/CandidateCounts';
import { IPositionProfileFilter } from '../common/models/filter/IPositionProfileFilter';
import { ICandidatePositionProfile } from '../common/models/candidate/ICandidatePositionProfile';
import { ICandidateUpdateStatus } from '../common/models/candidate/ICandidateUpdateStatus';
import { key, getCode } from '../common/helpers/common';
import { ICounterFilter } from '../common/models/filter/ICounterFilter';
import { IReportData } from '../common/models/candidate/IReportData';
import { IProfileCandidate } from '../common/models/candidate/IProfileCandidate';
import { IUpdateCandidatePosition } from '../common/models/candidate/IUpdateCandidatePosition';
import { IUpdateOwner } from '../common/models/candidate/IUpdateOwner';
import { IRefReqWorkspace } from '../common/models/workspace/IRefReqWorkspace';
import { IRefReqCandidateForm } from '../common/models/referenceRequest/IRefReqCandidateForm';
import { ICandidateRemind } from '../common/models/candidate/ICandidateRemind';

export const getCandidates = (payload: IFilter) => api.get<IListData<ICandidate>>(
  '/api/candidates/',
  { ...payload, sort: mapSortToSortReq(payload.sort), filter: mapFilterToFilterReq(payload.filter) }
);

export const sendReminder = (payload: ICandidateRemind) => api.post('/api/candidates/remind/bulk', payload);

export const updateCandidateOwner = ({ ids, owner: { id } }: IUpdateOwner) => (
  api.put('/api/candidates/owner', { ids, ownerId: id })
);

export const getProfileCandidateData = (candidateId: string) => api.get<IProfileCandidate>(
  `/api/candidates/${candidateId}/profile`
);

export const getCandidatesByPositionId = (payload: IPositionProfileFilter) => (
  api.get<IListData<ICandidatePositionProfile>>(
    `/api/positions/${payload.id}/candidates`,
    { ...payload, sort: mapSortToSortReq(payload.sort), filter: mapFilterToFilterReq(payload.filter) }
  )
);

export const getCounters = (payload: ICounterFilter) => api.get<CandidateCounts>(
  '/api/candidates/counters',
  { ...payload, filter: mapFilterToFilterReq(payload.filter) }
);

export const updateStatus = (payload: ICandidateUpdateStatus) => (
  api.put('/api/candidates/status', payload)
);

export const checkCode = (code: string) => api.get<IRefReqCandidateForm>(
  '/public-api/candidate-code/valid', { code, key }
);

export const checkKey = () => api.get<IRefReqWorkspace>('/public-api/candidate-key/valid', { key });

export const setCandidateConsent = () => api.put(`/candidate-api/consent?key=${key}&code=${getCode()}`);

export const getReport = (payload: IReportData) => (
  api.get('/api/candidates/report', payload)
);

export const updatePosition = (payload: IUpdateCandidatePosition) => api.put<{ positionId: string }>(
  '/api/candidates/position', payload
);
